import {MeasurementUnits, QualifierRange} from "../graphql";
//for break even in sorting added 0.0x
const yearsToHours = (years : number) : number => years * 12 * 30 * 24 + 0.04;
const monthToHours = (months : number) : number => months * 30 * 24 + 0.03;
const weeksToHours = (weeks: number) : number => weeks * 7 * 24 + 0.02;
const daysToHours = (days : number) : number => days * 24 + 0.01;

export const convertTimeRangeToHours = (range: QualifierRange) : number => {
    if (!range) return 0;
    switch (range.units) {
        case MeasurementUnits.Years: return yearsToHours(range.high);
        case MeasurementUnits.Months: return monthToHours(range.high);
        case MeasurementUnits.Weeks: return weeksToHours(range.high);
        case MeasurementUnits.Days: return daysToHours(range.high);
        default:
            return range.high;
    }
}